import React from "react";
import { defaultEntityTypeFilter } from "../const";
import Chip from "@common/components/Chips";
import { Log } from "@services/audit/types";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";
import { canEditAccountConfiguration } from "@common/utils/user";

interface EntityTypeIndicatorProps {
  trail?: Log;
}
const EntityTypeIndicator = (props: EntityTypeIndicatorProps) => {
  const { trail } = props;
  const { t } = useTranslation();
  const [user] = useAuthenticatedUser();
  const canEdit = canEditAccountConfiguration(user);
  const navigate = useNavigate();

  const entity = defaultEntityTypeFilter.find(
    (action) => action.type === trail?.entityType
  );

  const getURL = () => {
    switch (entity?.type) {
      case "ACCOUNT":
        return `/assets/accounts/${trail?.entityId}`;
      case "DEVICE":
        return `/assets/devices/${trail?.entityId}`;
      case "LOCATION":
        return `/assets/locations/${trail?.entityId}`;
      case "ROOM":
        return `/assets/rooms/${trail?.entityId}`;
      case "SYSTEM":
        return `/configuration/workflows/${trail?.entityId}`;
      default:
        return "";
    }
  };
  const url = getURL();

  return (
    <Chip
      label={entity?.label as string}
      icon={entity?.icon}
      fontSize="small"
      variant={trail?.entityId === undefined ? "outlined" : "contained"}
      clickable={trail?.entityId !== undefined}
      uppercase={false}
      disabled={url === "" || !canEdit}
      onClick={() =>
        navigate(url, {
          state: { previous: t("Audit Trails").toUpperCase() },
        })
      }
    />
  );
};

export default EntityTypeIndicator;
